import { useMutation, useQuery } from '@tanstack/react-query';
import { fetchPaymentToken, savePaymentMethod } from './payment.api';
import { PaymentMethod } from '../../models/payment.types';

export const usePaymentToken = () => useQuery({
  queryKey: ['paymentToken'],
  queryFn: () => fetchPaymentToken(),
});

export const useUpdatePaymentMutation = () => useMutation<void, Error, PaymentMethod>({
  mutationFn: async (paymentMethod: PaymentMethod) => savePaymentMethod(paymentMethod),
});
